<template>
  <q-page padding>
    <div class="row col-12 justify-between items-center">
      <span class="text-h6 text-weight-bold text-brand-5 texto-titulo">
        Criar Ativo por Catálogo
      </span>
      <router-link :to="{ name: 'ferramentaria-recebimento' }">
        <div
          style="cursor: pointer"
          class="row items-center text-weight-bold text-brand-5 container-link-voltar q-mr-md"
        >
          <q-icon class="q-mr-sm icon-texto" name="west" color="brand-5" />
          <span class="texto-titulo">Voltar</span>
        </div>
      </router-link>
    </div>
    <div class="row col-12 q-mt-lg">
      <CabecalhoNota :tipo="true" :documentoSerie="true" />
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 items-center q-mb-sm">
        <div
          class="row col-12 q-ml-md text-brand-5 text-weight-bold q-mb-md titulo-tabela"
        >
          Ferramentas do Catálogo
        </div>
        <div class="row col-12">
          <ComponenteFiltros
            :codigo="true"
            :classCodigo="'col-md col-xs-6'"
            :descricao="true"
            :classDescricao="'col-md col-xs-5'"
            :classGrupo="'col-md col-xs-6'"
            :subgrupo="true"
            :classSubgrupo="'col-md col-xs-5'"
            @enviarFiltro="receberFiltro"
          />
        </div>
      </div>
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        :rows="listaFerramentas"
        color="primary"
        :columns="columns"
        dense
        selection="single"
        row-key="uuid"
        :class="{ 'my-sticky-dynamic': !mobile }"
        flat
        hide-pagination
        :loading="loading"
        hide-bottom
        v-model:selected="selected"
        :grid="mobile"
        :rows-per-page-options="[0]"
      >
        <template v-slot:item="props">
          <div class="q-pa-xs row col-12">
            <q-card
              class="container-grid-table col-12 grid-style-transition q-mt-sm"
            >
              <div class="q-pa-sm">
                <div class="row col-12 items-center">
                  <div class="col-8">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Código:</strong>
                      <span> {{ props.row?.codigo }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Descrição:</strong>
                      <span> {{ props.row.descricao }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Grupo:</strong>
                      <span> {{ props.row.grupo.nome }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Subgrupo:</strong>
                      <span> {{ props.row.subgrupo.nome }}</span>
                    </div>
                  </div>
                  <div class="col">
                    <div class="row col-12">
                      <div
                        style="
                          border: 1px solid #707070;
                          height: 60px;
                          width: 60px;
                          border-radius: 5px;
                          padding: 1px;
                        "
                      >
                        <q-img
                          v-if="props.row.url"
                          fit="contain"
                          height="100%"
                          width="100%"
                          :src="props.row.url"
                        />
                        <q-img
                          v-else
                          fit="contain"
                          height="100%"
                          width="100%"
                          src="../../../assets/semImagem.jpg"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col q-ml-sm">
                    <div class="row col-12">
                      <q-btn
                        round
                        size="10px"
                        :icon="props.selected ? 'close' : 'add'"
                        :color="props.selected ? 'red' : 'secondary'"
                        :disable="disable"
                        @click="
                          (props.selected = !props.selected),
                            (rightDrawerOpen = true),
                            (editarItem = { ...props.row })
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </q-card>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td class="coluna-selecionar">
              <q-btn
                round
                size="10px"
                :icon="props.selected ? 'close' : 'add'"
                :color="props.selected ? 'red' : 'secondary'"
                :disable="disable"
                @click="
                  (props.selected = !props.selected),
                    (rightDrawerOpen = true),
                    (editarItem = { ...props.row })
                "
              />
            </q-td>
            <q-td>
              <div class="container-image">
                <q-img id="image-produto" :src="props.row.url" />
              </div>
            </q-td>
            <q-td>
              <span>{{ props.row.codigo }}</span>
            </q-td>
            <q-td>
              <span>{{ props.row.descricao }}</span>
            </q-td>
            <q-td>
              <span>{{ props.row.grupo.nome }}</span>
            </q-td>
            <q-td>
              <span>{{ props.row.subgrupo.nome }}</span>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          :size="mobile ? 'md' : 'sm'"
        />
      </div>
    </div>
    <div
      v-if="editarMultiplicado"
      class="q-mt-lg text-brand-5 text-weight-bold"
    >
      <q-expansion-item
        class="rounded-borders col-12 borda-container q-mt-sm"
        :style="{
          'border-color':
            ativosErrosIndicatorNew &&
            ativosErrosIndicatorNew?.indexOf(i.patrimonio) != -1
              ? 'red'
              : '',
        }"
        v-for="(i, index) in listaItensMultiplicados"
        :key="index"
        :label="`Item: ${index + 1} Código: ${i?.codigo} Descrição: ${
          i?.descricao
        }`"
      >
        <div :key="index" class="q-mt-sm q-px-md q-pb-md">
          <div
            class="row col-12 justify-between text-brand-5 q-my-md text-weight-bold"
          >
            <span class="text-brand-5 text-weight-bold text-h6"
              >Item {{ index + 1 }}</span
            >
          </div>
          <div
            class="row col-12 q-col-gutter-sm mobile2 text-brand-5 text-weight-bold"
          >
            <div class="col">
              Código
              <q-input disable v-model="i.codigo" dense outlined> </q-input>
            </div>
            <div class="col">
              Descrição
              <q-input disable v-model="i.descricao" dense outlined> </q-input>
            </div>
            <div class="col">
              Patrimônio
              <q-input disable v-model="i.patrimonio" dense outlined> </q-input>
            </div>
            <div class="col">
              Atributos
              <div v-if="i.atributos?.length > 0" class="row col-12 q-mt-sm">
                <span class="q-mr-sm" style="word-break: break-all"
                  ><strong>Chave: </strong>{{ i.atributos[0]?.chave }}</span
                >
                <span style="word-break: break-all"
                  ><strong>Valor: </strong>{{ i.atributos[0]?.valor
                  }}<span v-if="i.atributos?.length > 1">....</span></span
                >
                <q-tooltip v-if="i.atributos?.length > 1">
                  <div v-for="(atributo, index) in i?.atributos" :key="index">
                    <div class="row col-12" v-if="atributo.valor">
                      <div class="row col-12 justify-between">
                        <span class="q-mr-sm"
                          >Chave: {{ atributo.chave }}
                        </span>
                        <span>Valor: {{ atributo.valor }}</span>
                      </div>
                    </div>
                  </div>
                </q-tooltip>
              </div>
              <div v-else class="q-mt-sm">Sem Atributos</div>
            </div>
            <div class="col">
              Acessórios
              <div v-if="i.acessorios?.length > 0" class="row col-12 q-mt-sm">
                <span style="word-break: break-all"
                  ><strong>Nome: </strong>{{ i.acessorios[0]?.nome
                  }}<span v-if="i.acessorios?.length > 1">....</span></span
                >
                <q-tooltip v-if="i.acessorios?.length > 1">
                  <div v-for="(acessorio, index) in i?.acessorios" :key="index">
                    <div class="row col-12" v-if="acessorio.nome">
                      <div class="row col-12 justify-between">
                        <span class="q-mr-sm">Nome: {{ acessorio.nome }} </span>
                      </div>
                    </div>
                  </div>
                </q-tooltip>
              </div>
              <div v-else class="q-mt-sm">Sem Acessórios</div>
            </div>
            <div class="col">
              Checklists
              <div v-if="i.checkLists?.length > 0" class="row col-12 q-mt-sm">
                <span style="word-break: break-all"
                  ><strong>Nome: </strong>{{ i.checkLists[0]?.nome
                  }}<span v-if="i.checkLists?.length > 1">....</span></span
                >
                <q-tooltip v-if="i.checkLists?.length > 1">
                  <div v-for="(checklist, index) in i?.checkLists" :key="index">
                    <div class="row col-12" v-if="checklist.nome">
                      <div class="row col-12 justify-between">
                        <span class="q-mr-sm">Nome: {{ checklist.nome }} </span>
                      </div>
                    </div>
                  </div>
                </q-tooltip>
              </div>
              <div v-else class="q-mt-sm">Sem Checklist</div>
            </div>
            <div class="row col">
              <div class="row col-12">Editar</div>
              <div>
                <q-btn
                  icon="article"
                  color="blue"
                  round
                  @click="
                    (rightDrawerOpenItemMultiplicado = true),
                      (editarItemMultiplicado = { ...i });
                    indexAlterarMultiplicado = index;
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </q-expansion-item>
    </div>
    <div v-if="editarMultiplicado" class="row col-12 q-gutter-sm q-mt-md">
      <q-btn
        label="Criar"
        @click="criarAtivo(), (criarMultiplicado = true)"
        icon="done"
        color="positive"
        no-caps
      />
      <q-btn
        label="Cancelar"
        icon="cancel"
        color="negative"
        no-caps
        @click="cancelarItensMultiplicados()"
      />
    </div>
    <ModalAdicionarAtivoItem
      :itemCatalogo="editarItemMultiplicado"
      :rightDrawerOpen="rightDrawerOpenItemMultiplicado"
      :operacao="true"
      :multiplicar="false"
      :fornecedor="true"
      :esconderLocada="true"
      @fecharModal="rightDrawerOpenItemMultiplicado = false"
      @salvarAlteracoes="salvarAlteracoesItemMultiplicado"
    />
    <ModalAdicionarAtivoItem
      :itemCatalogo="editarItem"
      :rightDrawerOpen="rightDrawerOpen"
      :multiplicar="true"
      :criarAtivo="true"
      :operacao="true"
      :esconderLocada="true"
      :resetarMultiplo="resetarMultiplo"
      @fecharModal="rightDrawerOpen = false"
      @salvarAlteracoes="salvarAlteracoesItem"
      @multiplicarCampo="multiplicarCampos"
      @criarAtivo="criarAtivo"
    />
    <div
      v-if="rightDrawerOpen || rightDrawerOpenItemMultiplicado"
      @click="
        (rightDrawerOpen = false), (rightDrawerOpenItemMultiplicado = false)
      "
      class="mascara"
    ></div>
  </q-page>
</template>

<script>
import { ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";
import { useRouter } from "vue-router";

import ModalAdicionarAtivoItem from "../components/ModalAdicionarAtivoItem.vue";
import ComponenteFiltros from "../components/ComponenteFiltros.vue";
import CabecalhoNota from "../components/CabecalhoNota.vue";

const columns = [
  {
    name: "selecionar",
    label: "",
    align: "center",
  },
  {
    name: "imagem",
    label: "Imagem",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
  },
  {
    name: "subgrupo",
    label: "Subgrupo",
    align: "left",
  },
];
export default {
  components: {
    ModalAdicionarAtivoItem,
    ComponenteFiltros,
    CabecalhoNota,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();

    const selected = ref([]);
    const filtros = ref({ produto: "" });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });
    const listaFerramentas = ref([]);
    let rightDrawerOpen = ref(false);
    let rightDrawerOpenItemMultiplicado = ref(false);
    const atributosFerramentas = ref([]);
    const tab = ref("inicio");
    const subTab = ref("associar");
    const dadoCriarFerramenta = ref({});
    const imageUrl = ref("");
    const img = ref(null);
    let disable = ref(false);
    const options = ref({
      atributos: [{ label: "KG", value: "kg" }],
      checklist: [],
    });
    const checklistCriar = ref({ nome: "" });
    const arrayChecklist = ref([]);
    const checklist = ref({});
    const resetar = ref(0);
    const acessorioFerramenta = ref([]);
    const editarItemMultiplicado = ref({});
    const dadoAcessorio = ref("");
    const resetarChecklist = ref(0);
    const dadoAtributo = ref({ chave: "", valor: "" });
    const catalogoUuid = salvarCatalogoUuid();
    const listaFerramenta = ref([]);
    const itemCalogo = ref({});
    const editarItem = ref({});
    const ativosErrosIndicatorNew = ref([]);
    const valorMultiplo = ref(0);
    const listaItensMultiplicados = ref([]);
    let editarMultiplicado = ref(false);
    const resetarMultiplo = ref(0);
    let indexAlterarMultiplicado = ref("");
    let loading = ref(false);
    let criarMultiplicado = ref(false);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarFerramentas = async (page = 1, perPage = 10) => {
      if (catalogoUuid.catalogoUuid.value === null) {
        listaFerramentas.value = [];
        return;
      }
      try {
        disable.value = true;
        loading.value = true;
        const response = await store.dispatch(
          "ferramentaria/listarFerramentas",
          {
            perPage: perPage,
            page: page,
            codigo: filtros.value?.codigo,
            nome: filtros.value?.descricao,
            catalogoUuid: catalogoUuid.catalogoUuid.value,
            nomeGrupo: filtros.value?.grupo?.nome,
            catalogoSubGrupoUuid: filtros.value.subgrupo?.catalogoSubGrupoUuid,
            comCheckLists: "sim",
            comAcessorios: "sim",
            comAtributos: "sim",
          }
        );
        listaFerramentas.value = response.listaFerramentas;
        pagination.value.page = response.response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.response.data.resultado.total;
        pagination.value.rowsPerPage = response.response.data.resultado.perPage;
        disable.value = false;
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const adicionarLinhaAtributo = async () => {
      let valido = atributosFerramentas.value.every(
        (value) =>
          value.chave != dadoAtributo.value.chave &&
          value.valor != dadoAtributo.value.valor
      );
      if (dadoAtributo.value.chave == "" || dadoAtributo.value.valor == "") {
        quasar.notify({
          message: "O campo chave e valor não podem ser vazios.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (!valido) {
        quasar.notify({
          message:
            "Já existe um atributo com os mesmos valores adicionado ao item.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      atributosFerramentas.value.push({
        chave: dadoAtributo.value.chave,
        valor: dadoAtributo.value.valor,
      });
      resetAtributoCriar();
    };

    const verificarIndiceAtributo = (index) => {
      return atributosFerramentas.value[index + 1];
    };

    const removerIndiceAtributo = (index) => {
      atributosFerramentas.value.splice(index, 1);
    };

    const listarChecklist = async (val) => {
      try {
        const response = await store.dispatch("ferramentaria/listarChecklist");
        options.value.checklist = response.resultado.data;
        options.value.checklist = options.value.checklist.filter(
          (v) => v.nome.toLowerCase().indexOf(val) > -1
        );
      } catch (error) {
        console.log(error);
      }
    };

    const multiplicarCampos = (value) => {
      valorMultiplo.value = value.multiplo;
      for (let i = 0; i < value.multiplo; i++) {
        listaItensMultiplicados.value.push({
          expandido: true,
          catalogoItemUuid: value?.itemSelecionado.uuid,
          codigo: value?.itemSelecionado?.codigo,
          descricao: value.itemSelecionado?.descricao,
          fornecedor: value.itemSelecionado?.fornecedor,
          tempoPermanencia: value.itemSelecionado.tempoPermanencia,
          deposito: value.itemSelecionado?.deposito,
          responsavelId: value.itemSelecionado?.responsavel?.responsavelId,
          atributos: value.itemSelecionado?.atributos,
          acessorios: value.itemSelecionado?.acessorios,
          checkLists: value?.itemSelecionado?.checkLists,
          patrimonio: value?.itemSelecionado.patrimonio,
          origem: value?.itemSelecionado?.origem,
          valor: value?.itemSelecionado?.valor,
          valorLocacao: value?.itemSelecionado?.valorLocacao,
          operacao: value?.itemSelecionado?.operacao,
        });
      }
      editarMultiplicado.value = true;
      rightDrawerOpen.value = false;
      disable.value = true;
      criarMultiplicado.value = true;
    };

    const criarFerramenta = () => {
      setTimeout(() => {
        rightDrawerOpen.value = false;
        selected.value = [];
        quasar.notify({
          message: "Ferramenta criada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }, 500);
    };

    const adicionarLinhaChecklist = (checklist) => {
      if (arrayChecklist.value.length > 0) {
        let valido = arrayChecklist.value.every(
          (value) => value.checkListUuid != checklist.checkListUuid
        );
        if (!valido) {
          quasar.notify({
            message: "Checklist já adicionado.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
      }
      if (
        checklist.checkListUuid == "" ||
        checklist.checkListUuid == undefined
      ) {
        quasar.notify({
          message: "Selecione um checklist.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      arrayChecklist.value.push({
        checkListUuid: checklist.checkListUuid,
        nome: checklist.nome,
        descricao: checklist.descricao,
      });
      resetarChecklist.value++;
    };

    const receberChecklist = (value) => {
      checklist.value = value;
    };

    const criarChecklist = async () => {
      if (checklistCriar.value.nome === "") {
        quasar.notify({
          message: "O nome é obrigatório.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        const response = await store.dispatch(
          "ferramentaria/adicionarChecklist",
          {
            nome: checklistCriar.value.nome,
            descricao: checklistCriar.value.nome,
          }
        );
        quasar.notify({
          message: "Checklist criado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        checklist.value.checkListUuid = response.data.resultado.checkListUuid;
        adicionarLinhaChecklist({
          nome: checklistCriar.value.nome,
          descricao: checklistCriar.value.nome,
          checkListUuid: response.data.resultado.checkListUuid,
        });
        resetVariaveisChecklistCriar();
      } catch (error) {
        if (error.response?.data?.erros.mensagem) {
          quasar.notify({
            message: error.response.data.erros.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error?.response?.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const adicionarLinhaAcessorio = () => {
      if (dadoAcessorio.value == "") {
        quasar.notify({
          message: "O campo nome não pode ser vazio.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      acessorioFerramenta.value.push({ nome: dadoAcessorio.value });
      dadoAcessorio.value = "";
    };

    const removerIndiceAcessorio = (index) => {
      acessorioFerramenta.value.splice(index, 1);
    };

    const removerIndiceChecklist = (index) => {
      arrayChecklist.value.splice(index, 1);
    };

    const resetVariaveisChecklistCriar = () => {
      checklistCriar.value = {
        nome: "",
      };
    };

    const resetAtributoCriar = () => {
      dadoAtributo.value = {
        chave: "",
        valor: "",
      };
    };

    const salvarAlteracoesItem = (value) => {
      let index = listaFerramentas.value.findIndex(
        (item) => item.uuid == value.uuid
      );
      listaFerramentas.value.splice(index, 1, value);
    };

    const salvarAlteracoesItemMultiplicado = (value) => {
      listaItensMultiplicados.value.splice(
        indexAlterarMultiplicado.value,
        1,
        value
      );
    };

    const receberFiltro = (value) => {
      filtros.value = value;
      listarFerramentas();
    };

    const criarAtivo = async (value) => {
      if (
        store.state.ferramentaria?.cabecalhoNota?.fornecedor?.parceiroId ==
        undefined
      ) {
        quasar.notify({
          message: "O campo fornecedor não pode ser vazio.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      let itens = [];
      if (!criarMultiplicado.value) {
        if (value.itemSelecionado?.multiplo > 1) {
          for (let i = 1; i <= value.itemSelecionado?.multiplo; i++) {
            itens.push({
              operacaoUuid:
                value.itemSelecionado?.operacao?.transferenciaOperacaoUuid,
              novoAtivo: {
                catalogoItemUuid: value.itemSelecionado?.uuid,
                codigo: value.itemSelecionado?.codigo,
                documentoTipo:
                  store.state.ferramentaria?.cabecalhoNota?.tipo?.value,
                documentoSerie: store.state.ferramentaria?.cabecalhoNota?.serie,
                documentoNumero:
                  store.state.ferramentaria?.cabecalhoNota?.numeroNota,
                fornecedorId:
                  store.state.ferramentaria?.cabecalhoNota?.fornecedor
                    ?.parceiroId,
                documentoEmissao:
                  store.state.ferramentaria?.cabecalhoNota?.fornecedor?.dataEmissao
                    ?.split("/")
                    .reverse()
                    .join("-"),
                tempoPermanencia: parseFloat(
                  value.itemSelecionado?.tempoPermanencia
                ),
                depositoLocalUuid:
                  value.itemSelecionado?.deposito?.depositoLocalUuid,
                responsavelId: value.itemSelecionado?.responsavelId,
                atributos:
                  value.itemSelecionado?.atributos.length > 0
                    ? montarAtributoArray(value.itemSelecionado?.atributos)
                    : undefined,
                acessorios:
                  value.itemSelecionado?.acessorios.length > 0
                    ? montarAcessorioArray(value.itemSelecionado?.acessorios)
                    : undefined,
                checkLists:
                  value.itemSelecionado?.checkLists.length > 0
                    ? montarChecklistArray(value.itemSelecionado?.checkLists)
                    : undefined,
                patrimonio: value.itemSelecionado?.patrimonio,
                origem: value.itemSelecionado?.origem?.value,
                preco: parseFloat(value.itemSelecionado?.valor),
                valorLocacao: parseFloat(value.itemSelecionado?.valorLocacao),
              },
            });
          }
        } else {
          itens.push({
            operacaoUuid:
              value.itemSelecionado?.operacao?.transferenciaOperacaoUuid,
            novoAtivo: {
              catalogoItemUuid: value.itemSelecionado?.uuid,
              codigo: value.itemSelecionado?.codigo,
              documentoTipo:
                store.state.ferramentaria?.cabecalhoNota?.tipo?.value,
              documentoSerie: store.state.ferramentaria?.cabecalhoNota?.serie,
              documentoNumero:
                store.state.ferramentaria?.cabecalhoNota?.numeroNota,
              fornecedorId:
                store.state.ferramentaria?.cabecalhoNota?.fornecedor
                  ?.parceiroId,
              documentoEmissao:
                store.state.ferramentaria?.cabecalhoNota?.dataEmissao
                  ?.split("/")
                  .reverse()
                  .join("-"),
              tempoPermanencia: parseFloat(
                value.itemSelecionado?.tempoPermanencia
              ),
              depositoLocalUuid:
                value.itemSelecionado?.deposito?.depositoLocalUuid,
              responsavelId: value.itemSelecionado?.responsavelId,
              atributos:
                value.itemSelecionado?.atributos.length > 0
                  ? montarAtributoArray(value.itemSelecionado?.atributos)
                  : undefined,
              acessorios:
                value.itemSelecionado?.acessorios.length > 0
                  ? montarAcessorioArray(value.itemSelecionado?.acessorios)
                  : undefined,
              checkLists:
                value.itemSelecionado?.checkLists.length > 0
                  ? montarChecklistArray(value.itemSelecionado?.checkLists)
                  : undefined,
              patrimonio: value.itemSelecionado?.patrimonio,
              origem: value.itemSelecionado?.origem?.value,
              preco: parseFloat(value.itemSelecionado?.valor),
              valorLocacao: parseFloat(value.itemSelecionado?.valorLocacao),
            },
          });
        }
      } else {
        listaItensMultiplicados.value.forEach((item) => {
          itens.push({
            operacaoUuid: item?.operacao?.transferenciaOperacaoUuid,
            novoAtivo: {
              catalogoItemUuid: item?.catalogoItemUuid,
              codigo: item?.codigo,
              documentoTipo:
                store.state.ferramentaria?.cabecalhoNota?.tipo?.value,
              documentoSerie: store.state.ferramentaria?.cabecalhoNota?.serie,
              fornecedorId:
                store.state.ferramentaria?.cabecalhoNota?.fornecedor
                  ?.parceiroId,
              documentoNumero:
                store.state.ferramentaria?.cabecalhoNota?.numeroNota,
              documentoEmissao:
                store.state.ferramentaria?.cabecalhoNota?.dataEmissao
                  ?.split("/")
                  .reverse()
                  .join("-"),
              tempoPermanencia: parseFloat(item?.tempoPermanencia),
              depositoLocalUuid: item?.deposito?.depositoLocalUuid,
              responsavelId: item?.responsavelId,
              atributos:
                item?.atributos.length > 0
                  ? montarAtributoArray(item?.atributos)
                  : undefined,
              acessorios:
                item?.acessorios.length > 0
                  ? montarAcessorioArray(item?.acessorios)
                  : undefined,
              checkLists:
                item?.checkLists.length > 0
                  ? montarChecklistArray(item?.checkLists)
                  : undefined,
              patrimonio: item?.patrimonio,
              origem: item?.origem?.value,
              preco: parseFloat(item?.valor),
              valorLocacao: parseFloat(item?.valorLocacao),
            },
          });
        });
      }
      let valido = verificarCampoPreenchido(itens);
      if (!valido) {
        return;
      }
      try {
        ativosErrosIndicatorNew.value = [];
        await store.dispatch("ferramentaria/criarTransferenciaManual", {
          unidadeId: store.state.org.unidadeData.id,
          etapa: "transferencia_manual_estoque",
          usuarioId: store.state.autenticacao.usuarioLogado.id,
          usuarioNome: store.state.autenticacao.usuarioLogado.nome,
          documentoTipo: store.state.ferramentaria?.cabecalhoNota?.tipo.value,
          documentoSerie: store.state.ferramentaria?.cabecalhoNota?.serie,
          documentoNumero: store.state.ferramentaria?.cabecalhoNota?.numeroNota,
          documentoEmissao:
            store.state.ferramentaria?.cabecalhoNota?.dataEmissao
              ?.split("/")
              .reverse()
              .join("-"),
          ativos: itens,
        });
        cancelarItensMultiplicados();
        router.push({ name: "ferramentaria-recebimento" });
        quasar.notify({
          message: "Itens enviados com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        ativosErrosIndicatorNew.value.push(
          error.response?.data?.erros?.dados?.patrimonio
        );

        if (error?.response?.data?.erros?.erro) {
          quasar.notify({
            message: error?.response?.data?.erros?.erro,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response?.data?.erro?.detalhes?.ativos) {
          for (const key in error.response?.data?.erro?.detalhes?.ativos) {
            if (
              Object.hasOwnProperty.call(
                error.response?.data?.erro?.detalhes?.ativos,
                key
              )
            ) {
              const element = error.response?.data?.erro?.detalhes?.ativos[key];
              quasar.notify({
                message: `${key.charAt(0).toUpperCase()}${key.substring(
                  1
                )} ${element}`,
                color: "negative",
                actions: [
                  {
                    label: "Fechar",
                    color: "white",
                    handler: () => {
                      /* ... */
                    },
                  },
                ],
              });
            }
          }
        }
        disable.value = false;
      }
    };

    const verificarCampoPreenchido = (array) => {
      let campoPreenchido = true;
      for (let i = 0; i < array.length; i++) {
        const linha = array[i];
        if (
          linha.novoAtivo?.depositoLocalUuid == undefined ||
          linha.novoAtivo?.depositoLocalUuid == ""
        ) {
          quasar.notify({
            message: `Preencha o campo local de deposito do item ${
              linha.novoAtivo?.codigo
            } ${editarMultiplicado.value ? `Item: ${i + 1}` : ""}`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          campoPreenchido = false;
        }
        if (
          linha.novoAtivo?.tempoPermanencia === undefined ||
          linha.novoAtivo?.tempoPermanencia === ""
        ) {
          campoPreenchido = false;
          quasar.notify({
            message: `Preencha o campo tempo de permanencia do item ${
              linha.novoAtivo?.codigo
            } ${editarMultiplicado.value ? `Item: ${i + 1}` : ""}`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (
          linha.novoAtivo?.origem == "" ||
          linha.novoAtivo?.origem == undefined
        ) {
          campoPreenchido = false;
          quasar.notify({
            message: `Preencha o campo origem do item ${
              linha.novoAtivo?.codigo
            } ${editarMultiplicado.value ? `Item: ${i + 1}` : ""}`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (linha.operacaoUuid == "" || linha.operacaoUuid == undefined) {
          campoPreenchido = false;
          quasar.notify({
            message: `Preencha o campo operação do item ${
              linha.novoAtivo?.codigo
            } ${editarMultiplicado.value ? `Item: ${i + 1}` : ""}`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (
          linha.novoAtivo?.origem != "consumo" &&
          (linha.novoAtivo?.patrimonio == "" ||
            linha.novoAtivo?.patrimonio == undefined)
        ) {
          campoPreenchido = false;
          quasar.notify({
            message: `Preencha o campo patrimonio do item ${
              linha.novoAtivo?.codigo
            } ${editarMultiplicado.value ? `Item: ${i + 1}` : ""}`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (!campoPreenchido) {
          break;
        }
      }
      return campoPreenchido;
    };

    const montarChecklistArray = (arrayChecklist) => {
      let array = [];
      arrayChecklist.forEach((checklist) => {
        array.push({
          checkListUuid: checklist.checkListUuid,
        });
      });
      return array;
    };

    const montarAcessorioArray = (arrayAcessorio) => {
      let array = [];
      arrayAcessorio.forEach((acessorio) => {
        if (acessorio.uuid) {
          array.push({
            acessorioUuid: acessorio.uuid,
          });
        } else {
          array.push({
            nome: acessorio.nome,
          });
        }
      });
      return array;
    };

    const montarAtributoArray = (arrayAtributo) => {
      let array = [];
      arrayAtributo.forEach((atributo) => {
        array.push({
          chave: atributo.chave,
          valor: atributo.valor,
        });
      });
      return array;
    };

    const cancelarItensMultiplicados = () => {
      editarMultiplicado.value = false;
      selected.value = [];
      rightDrawerOpen.value = false;
      listaItensMultiplicados.value = [];
      disable.value = false;
      resetarMultiplo.value++;
      criarMultiplicado.value = false;
    };

    watch(
      () => pagination.value.page,
      () => {
        listarFerramentas(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => catalogoUuid.catalogoUuid.value,
      () => {
        listarFerramentas();
      }
    );

    watch(
      () => img.value,
      () => {
        if (dadoCriarFerramenta.value.url != null && img.value?.name) {
          dadoCriarFerramenta.value.url = "";
        }
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarFerramentas(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => rightDrawerOpen.value,
      () => {
        if (rightDrawerOpen.value == false && !editarMultiplicado.value) {
          selected.value = [];
        }
      }
    );

    watch(
      () => filtros.value.produto,
      () => {
        listarFerramentas();
      }
    );

    onMounted(() => {
      listarFerramentas();
    });

    return {
      columns,
      listaFerramentas,
      selected,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      rightDrawerOpen,
      adicionarLinhaAtributo,
      verificarIndiceAtributo,
      resetarMultiplo,
      removerIndiceAtributo,
      tab,
      subTab,
      dadoCriarFerramenta,
      verificarCampoPreenchido,
      atributosFerramentas,
      valorMultiplo,
      indexAlterarMultiplicado,
      salvarAlteracoesItemMultiplicado,
      criarMultiplicado,
      imageUrl,
      img,
      disable,
      loading,
      filtros,
      checklist,
      listarChecklist,
      criarChecklist,
      criarFerramenta,
      acessorioFerramenta,
      dadoAcessorio,
      receberFiltro,
      options,
      rightDrawerOpenItemMultiplicado,
      editarItemMultiplicado,
      checklistCriar,
      removerIndiceAcessorio,
      adicionarLinhaChecklist,
      receberChecklist,
      arrayChecklist,
      resetVariaveisChecklistCriar,
      resetar,
      itemCalogo,
      removerIndiceChecklist,
      adicionarLinhaAcessorio,
      resetarChecklist,
      catalogoUuid,
      dadoAtributo,
      criarAtivo,
      listaFerramenta,
      salvarAlteracoesItem,
      editarItem,
      mobile,
      multiplicarCampos,
      editarMultiplicado,
      listaItensMultiplicados,
      cancelarItensMultiplicados,
      montarChecklistArray,
      montarAcessorioArray,
      ativosErrosIndicatorNew,
      montarAtributoArray,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 430px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
.borda-container {
  border: 1px solid #707070;
  border-radius: 4px;
}
#image-produto {
  width: 100%;
  height: 100%;
}
.container-image {
  border: 1px solid #707070;
  border-radius: 4px;
  width: 60px;
  height: 60px;
  padding: 1px;
}
.container-tabela {
  margin-top: 10px;
}
tbody tr td {
  white-space: pre-wrap;
}
.input-filtro-container {
  margin-top: 29px;
}
container {
  height: 100%;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
a {
  text-decoration: none;
}
input[type="file"] {
  display: none;
}
.imagem-ferramenta-container {
  border: 1px solid black;
}
.imagem-ferramenta {
  width: 100%;
  height: 250px;
}
.container-imagem {
  height: 210px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #707070;
  border-radius: 10px;
  overflow: hidden;
}
.file-container {
  width: 100%;
  background: transparent;
  z-index: 30 !important;
}
.texto-alterar-imagem {
  color: black !important;
  z-index: 31;
  cursor: pointer;
  transition: all 0.5s;
}
.texto-alterar-imagem:hover {
  transform: scale(1.2);
}
.texto-excluir-pai {
  text-align: center;
  text-justify: inter-word;
  font-size: 23px;
  font-weight: bold;
  color: black;
}
.texto-excluir-filho {
  text-align: center;
  text-justify: inter-word;
  font-size: 15px;
}
.btn-excluir {
  font-size: 16px;
  padding: 0px 25px;
}
.input-atributo {
  margin-top: 25px;
}
.icon {
  margin-top: 26px;
}
.espaco {
  margin-top: 1px;
}
tbody tr .coluna-selecionar {
  width: 40px !important;
  margin: 0px;
  padding: 3px 2px;
}
.container-link-voltar {
  margin-right: 0px;
}
.icon-texto {
  font-size: 25px;
}
.titulo-tabela {
  font-size: 18px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.texto-titulo {
  font-size: 20px;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .container-btn-cadastro {
    margin: 17px 0px 0px 0px;
  }
  .btn-cadastro {
    font-size: 13px;
  }
  .container-tab {
    margin: 10px 0px 0px 0px;
  }
  .icon-modal {
    font-size: 19px;
    margin-right: 3px;
  }
  .texto-titulo-modal {
    font-size: 14px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .input-modal {
    font-size: 12px;
  }
  .btn-modal {
    font-size: 13px;
  }
  .imagem-ferramenta {
    width: 100%;
    height: 150px;
  }
  .container-imagem {
    height: 150px;
  }
  .texto-alterar-imagem {
    font-size: 10px;
  }
  .file {
    height: 120px;
  }
  .btn-editar-container {
    margin-bottom: 20px;
  }
  .input-mobile {
    font-size: 12px;
  }
  .container-modal-excluir {
    width: 100%;
    height: 250px;
    padding: 10px 10px 0px 10px;
    margin: 0px;
    border-radius: 10px;
  }
  .texto-excluir-pai {
    font-size: 17px;
  }
  .texto-excluir-filho {
    font-size: 14px;
  }
  .btn-excluir {
    font-size: 14px;
  }
  .texto-titulo-tabela {
    font-size: 13px;
    margin-bottom: 10px;
  }
  .texto-conteudo-tabela {
    font-size: 12px;
  }
  .icon-tabela {
    font-size: 12px;
  }
  .icon-texto {
    font-size: 20px;
    margin-right: 1px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
}
</style>
